<template>
	<div class="pain-note-list">
		<!-- ローディング -->
		<transition name="fade">
			<redraw-progress v-if="isLoading" />
		</transition>
		<!-- /ローディング -->
		<!-- エラー処理 -->
		<transition name="fade">
			<common-error-alert
				v-show="isError"
				@reload="reload"
			/>
		</transition>
		<!-- /エラー処理 -->
		<nav
			v-if="isFamilyCarePlus"
			class="pain-note-list__pain-selector"
		>
			<ul class="pain-note-list__pain-selector--list">
				<li :class="[
					'pain-note-list__pain-selector--item',
					{ 'is-selected': painLevels ? painLevels.indexOf('1') !== -1 : true }
				]">
					<a href="javascript:void(0);" @click="sortPain('1')">
						<i :class="`sprite${petClass} sprite${petClass}-pain1${painLevels && painLevels.indexOf('1')  === -1 ? '_off' : '' }`"></i>
					</a>
				</li>
				<li :class="[
					'pain-note-list__pain-selector--item',
					{ 'is-selected': painLevels ? painLevels.indexOf('2') !== -1 : true }
				]">
					<a href="javascript:void(0);" @click="sortPain('2')">
						<i :class="`sprite${petClass} sprite${petClass}-pain2${painLevels && painLevels.indexOf('2')  === -1 ? '_off' : '' }`"></i>
					</a>
				</li>
				<li :class="[
					'pain-note-list__pain-selector--item',
					{ 'is-selected': painLevels ? painLevels.indexOf('3') !== -1 : true }
				]">
					<a href="javascript:void(0);" @click="sortPain('3')">
						<i :class="`sprite${petClass} sprite${petClass}-pain3${painLevels && painLevels.indexOf('3')  === -1 ? '_off' : '' }`"></i>
					</a>
				</li>
				<li :class="[
					'pain-note-list__pain-selector--item',
					{ 'is-selected': painLevels ? painLevels.indexOf('4') !== -1 : true }
				]">
					<a href="javascript:void(0);" @click="sortPain('4')">
						<i :class="`sprite${petClass} sprite${petClass}-pain4${painLevels && painLevels.indexOf('4')  === -1 ? '_off' : '' }`"></i>
					</a>
				</li>
			</ul>
		</nav>
		<div
			v-if="painEmptyFlg"
			class="pain-note-list__empty"
		>
			<p>記録がまだありません。<br>鉛筆ボタンから記録をつけ始めましょう！</p>
		</div>
		<div
			id="js_list"
			class="list"
		>
			<div
				v-for="painItem in painDataList"
				:key="`item-${painItem.id}`"
				class="list-item"
			>
				<h2
					v-if="painItem.date"
					:key="`header-${painItem.id}`"
					class="pain-note-list__heading list-header"
				>
					{{ painItem.date }}
				</h2>
				<a
					class="pain-note-list__contents"
					:href="`native://openGraph?at=${painItem.unix_time}`"
				>
					<div class="pain-note-list__contents-left">
						<time
							:datetime="painItem.time"
							class="pain-note-list__contents-time"
						><span class="pain-note-list__contents-time-hour">{{ painItem.hour }}</span>時</time>
						<figure class="pain-note-list__contents-left-bottom">
							<!-- NOTE: level0でも「OK 通常」を表示するよう仕様変更。「.sprite-pressure_level0」で統一化した。 -->
							<i :class="`pain-note-list__contents-left-level-icon sprite sprite-pressure_level${painItem.pressure_level}`" />
							<i
								v-if="painItem.menstruation"
								:class="`pain-note-list__contents-left-menstruation sprite-menstruation list_${painItem.menstruation}`"
							/>
						</figure>
					</div>
					<div class="pain-note-list__contents-center">
						<div class="pain-note-list__contents-center-inner">
							<div class="pain-note-list__contents-temperature">
								<span class="pain-note-list__contents-heading">
									<span class="pain-note-list__contents-weather"><i :class="`pain-note-list__contents-weather-icon sprite sprite-weather${painItem.weather_codeicon}`" /></span>
									{{ painItem.weather_codetext }}<br>気温<span class="pain-note-list__contents-unit">(&#8451;)</span>
								</span>
								<span class="pain-note-list__contents-value">{{ painItem.temperature }}</span>
							</div>
							<div class="pain-note-list__contents-pressure">
								<span class="pain-note-list__contents-heading is-wide">気圧<span class="pain-note-list__contents-unit">(hpa)</span><br>{{ painItem.pressure_diffhour }}</span>
								<span class="pain-note-list__contents-value is-wide">{{ painItem.pressure }}<br>{{ painItem.pressure_diffvalue }}</span>
							</div>
						</div>
						<div
							:class="[
								'pain-note-list__contents-center-inner',
								{ 'is-have-drag': painItem.drug }
							]"
						>
							<div class="pain-note-list__contents-record">
								<i :class="`pain-note-list__contents-pain sprite${petClass} sprite${petClass}-pain${painItem.pain}`" />
								<i
									v-if="painItem.drug"
									:class="`pain-note-list__contents-drug sprite sprite-drug${painItem.drug}`"
								/>
							</div>
							<div class="pain-note-list__contents-medicine">
								<p
									v-if="painItem.medicine_names"
									class="is-medicine"
								>{{ painItem.medicine_names }}</p>
								<p
									v-if="painItem.prescription_names"
									class="is-prescription"
								>{{ painItem.prescription_names }}</p>
								<p v-if="(!painItem.medicine_names && !painItem.prescription_names) && painItem.drug_name">{{ painItem.drug_name }}</p>
							</div>
							<div
								v-show="painItem.comment"
								:class="[
									'pain-note-list__contents-comment',
									`is-${painItem.comment_state}`
								]"
								@click.prevent="painItem.comment_state === 'close' ? painItem.comment_state = 'open' : painItem.comment_state = 'close'"
							>
								<p v-html="painItem.comment"></p>
								<svg class="is-close" width="17" height="11" viewBox="0 0 17 11" fill="none">
									<rect width="17" height="11" rx="4" fill="#999999"/>
									<path d="M11.9531 3.77441L8.51225 7.22456L5.05284 3.77441" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
								</svg>
								<svg class="is-open"  width="17" height="11" viewBox="0 0 17 11" fill="none">
									<rect x="17" y="11" width="17" height="11" rx=" 4" transform="rotate(-180 17 11)" fill="#999999"/>
									<path d="M5.04688 7.22559L8.48775 3.77544L11.9472 7.22559" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
								</svg>
							</div>
						</div>
					</div>
					<div class="pain-note-list__contents-right">
						<svg class="pain-note-list__contents-right_icon" width="20" height="21" viewBox="0 0 20 21" fill="none">
							<path d="M7 4.50006L13 10.4839L7 16.5001" stroke-width="2"/>
						</svg>
					</div>
				</a>
			</div>
		</div>
	</div>
</template>

<script>
// Vuex
import { mapActions, mapGetters } from 'vuex'
import { SET_PAIN_DATA } from '@/store/modules/painNote/mutation-types'
import { SET_MENSTRUATION_DATA } from '@/store/modules/menstruation/mutation-types'
import { SET_CHIP_DATA } from '@/store/modules/common/mutation-types'

// Compornents
import RedrawProgress from '@/components/Molecules/RedrawProgress'
import CommonErrorAlert from '@/components/Molecules/CommonErrorAlert'

// ライブラリ
// import cmnConst from '@/assets/js/constant.js'
import moment from 'moment'
moment.locale('ja')

// NOTE: npmプライベートパッケージ
// https://github.com/pocke-Inc/zutool_chip_parser_web
const ZutoolChipParserWeb = require('@pocke-Inc/zutool_chip_parser_web')

// 初期・更新件数
const dataLimit = 50

export default {
	name: 'PainNoteList',
	components: {
		RedrawProgress,
		CommonErrorAlert
	},
	data () {
		return {
			painDataList: null,
			dateHeader: null,
			offset: 0,
			limit: dataLimit,
			currentPainDataLen: null,
			painEmptyFlg: false,
			limitMaxFlg: false,
			isLoading: false,
			isError: false,
			includeRiseWarning: 0,
			isFamilyCarePlus: false,
			elemList: null,
			petClass: '',
			painLevels: ['1', '2', '3', '4']
		}
	},

	computed: {
		// map Vuex getters
		...mapGetters('painNote', ['painData']),
		...mapGetters('menstruation', ['menstruationData']),
		...mapGetters('common', ['userId', 'userToken', 'viewMode', 'isWebview', 'userData', 'premiumType', 'chipData'])
	},

	created () {
		// premiumTypeが10（ファミリーケアプラス）の場合は痛みソート機能・ペットアイコンの判定
		this.isFamilyCarePlus = this.premiumType.premium_type_code === 10
		// this.isFamilyCarePlus = this.premiumType.premium_type_code !== 10	// debug用
		if (this.isFamilyCarePlus) {
			// userData.typeが1（人）でない場合はペットアイコンを有効にする
			this.petClass = this.userData.type !== 1 ? '-pet' : ''
			// this.petClass = this.userData.type === 1 ? '-pet' : ''	// debug用
		}
	},

	mounted () {
		this.includeRiseWarning = 1	// 気圧アラート取得のフラグを立てる
		this.getPainData()
		this.elemList = document.getElementById('js_list')
		this.elemList.addEventListener('scroll', this.updatedPainData)
	},

	beforeUnmount () {
		// イベントの破棄
		if (this.elemList) {
			this.elemList.removeEventListener('scroll', this.updatedPainData)
		}
	},

	methods: {
		// map Vuex actions
		...mapActions('painNote', [SET_PAIN_DATA]),
		...mapActions('menstruation', [SET_MENSTRUATION_DATA]),
		...mapActions('common', [SET_CHIP_DATA]),

		/**
		 * 記録データ取得(件数)処理
		 */
		getPainData () {
			this.isLoading = true
			this.SET_PAIN_DATA({
				user_id: this.userId,
				user_token: this.userToken,
				offset: this.offset,
				limit: this.limit,
				include_rise_warning: this.includeRiseWarning,
				pain_levels: this.painLevels.length === 4 ? null : this.painLevels
			}).then(res => {	// 痛み記録APIのレスポンス処理
				const isFemale = this.userData && (this.userData.sex === '2' || this.userData.sex === 2)
				// NOTE: 女性であれば生理日記録の処理をする
				if (isFemale) {
					// 痛み記録データの最初と最後の要素をみて期間を決める（痛みデータがない場合は現在時刻を指定して空データを返してもらう）
					const from = this.painData.records.length !== 0 ? this.painData.records[this.painData.records.length - 1].hour.sec : moment().unix()
					const to = this.painData.records.length !== 0 ? this.painData.records[0].hour.sec : moment().unix()
					// NOTE: 生理日記録の取得
					return this.SET_MENSTRUATION_DATA({
						user_id: this.userId,
						user_token: this.userToken,
						from: from,
						to: to
					})
				} else {
					// NOTE: 男性の場合、履行されたPromiseを返す（不要だが念のためtrueを履行結果として渡す）
					return Promise.resolve(true)
				}
			}).then(res => {	// 生理日記録APIのレスポンス処理
				// NOTE: チップデータ取得
				return this.SET_CHIP_DATA({
					type: 99	// 1: 人, 99: 動物 NOTE: 現状は動物のみ
				})
			}).then(res => {	// チップ取得APIのレスポンス処理
				const getPainDataList = this.painData.records.map(item => {
					// NOTE: 生理日記録の処理
					let menstruation = null
					const menstruationData = this.menstruationData ? this.menstruationData.records : []
					for (let i = 0, len = menstruationData.length; i < len; i++) {
						const data = menstruationData[i]
						switch (true) {
							// NOTE: 予定日はリストに表示させない（痛み登録と生理記録は必ず同じタイミングで登録されるのでこのケースは生理記録機能導入時のみ考えられる）
							// NOTE: 生理日記録の開始日と終了日は同じ日時（YYYYMMDDHH）で比較する（unix_timeそのものの比較だとsecまで同じでないとイコールにならないため）
							case data.is_expected:
								break
							case moment.unix(data.from_time.sec).isSame(moment.unix(item.hour.sec), 'hour'):
								menstruation = 'start_desc'
								break
							case moment.unix(data.to_time.sec).isSame(moment.unix(item.hour.sec), 'hour'):
								menstruation = 'end_desc'
								break
							case data.from_time.sec < item.hour.sec && data.to_time.sec > item.hour.sec:
								menstruation = 'during'
								break
						}
					}
					// NOTE: 複数服薬での変更内容
					// drug_namesからmedicinesを参照するよう変更し、複数の薬を表示できるようにした。旧バージョンとの互換性を保つためmedicinesがない場合はdrug_namesを表示する。
					// 市販薬・処方薬のアイコンをつけ分けてあいうえお順にソートして表示する（ない場合は今まで通り表示しない）。
					// 「その他のくすり」は例外で一番最後にする。ID（other_otc=市販薬・other_prescription=処方薬）をみて判定する
					const medicines = item.medicines ? item.medicines : null
					const drugName = medicines	// 旧バージョン用の表示
						? medicines.map(medicine => medicine.name).join()
						: item.drug_names && item.drug_names[0] !== 'null'
							? item.drug_names[0]
							: ''
					const getMedicineString = (medicines, type) => {	// 市販薬・処方薬を分けてあいうえお順でソートした文字列を返すローカル関数
						const otherMedicineID = type === 0 ? 'other_otc' : 'other_prescription'
						return medicines ? medicines
							.filter(medicine => Number(medicine.prescription_flag) === type)
							.sort((a, b) => {
								if (a.id === otherMedicineID) {	// aが「その他のくすり」ならaをbの後ろに並べる
									return 1
								} else if (b.id === otherMedicineID) {	// bが「その他のくすり」ならaをbの前に並べる
									return -1
								} else {	// 「その他のくすり」以外は通常の判定
									return a.name_hira < b.name_hira ? -1 : a.name_hira > b.name_hira ? 1 : 0
								}
							})
							.map(medicine => medicine.name).join()
							: ''
					}
					const medicineNames = getMedicineString(medicines, 0)	// 市販薬
					const prescriptionNames = getMedicineString(medicines, 1)	// 処方薬
					return {
						'id': item._id,
						'time': moment.unix(item.hour.sec).format('YYYY-MM-DDTHH:mm'),
						'unix_time': item.hour.sec,	// ネイティブアプリのhref値につけるエポックタイム(秒)
						'date': this.dateItem(`${moment.unix(item.hour.sec).format('YYYY年MM月DD日(ddd)')}`),
						'hour': moment.unix(item.hour.sec).hour(),
						'pressure_level': item.weather.pressure_level,
						'weather_codeicon': item.weather.weather_code,
						'weather_codetext': this.weatherCodetextItem(item.weather.weather_code),
						'temperature': item.weather.temperature,
						'pressure': item.weather.pressure,
						'pressure_diffhour': this.pressureDiffhourItem(moment.unix(item.hour.sec).hour()),
						'pressure_diffvalue': this.pressureDiffvalueItem(item.weather.pressure_diff),
						'pain': item.pain,
						'drug': this.drugItem(item.drug),
						'drug_name': drugName,
						'medicine_names': medicineNames,
						'prescription_names': prescriptionNames,
						'comment': item.comment ? this.convertChipComment(item.comment) : '',
						'comment_state': 'hidden',	// コメントの開閉状態の初期値
						'menstruation': menstruation
					}
				})

				this.painDataList = this.painDataList ? this.painDataList.concat(getPainDataList) : getPainDataList
				this.painEmptyFlg = Object.keys(this.painDataList).length === 0
				this.currentPainDataLen !== this.painDataList.length && !(this.painDataList.length % dataLimit) ? this.currentPainDataLen = this.painDataList.length : this.limitMaxFlg = true

				this.$nextTick(() => {
					this.addCommentClass()
				})
			}).catch(error => {
				console.log(error)
				this.isError = true
			}).finally(() => {
				this.isLoading = false
			})
		},

		/**
		 * 日付表示
		 */
		dateItem (e) {
			if (this.dateHeader !== e) {
				this.dateHeader = e
				return e
			} else {
				return null
			}
		},

		/**
		 * 天気表示
		 */
		weatherCodetextItem (e) {
			e = Number(e)
			return e === 1 ? '晴れ' : e === 2 ? 'くもり' : e === 3 ? '雨' : '雪'
		},

		/**
		 * 気圧差の時間帯表示
		 */
		pressureDiffhourItem (e) {
			return e >= 3 && e < 9 ? '03-09' : e >= 9 && e < 15 ? '09-15' : e >= 15 && e < 21 ? '15-21' : '21-03'
		},

		/**
		 * 気圧差の値表示
		 */
		pressureDiffvalueItem (e) {
			return e > 0 ? `+${e}` : e
		},

		/**
		 * 薬アイコン表示
		 */
		drugItem (e) {
			e = Number(e)
			return e === 1 ? null : e
		},

		/**
		 * 表示件数の上限追加
		 */
		updatedPainData (e) {
			// TODO: リスト表示に関する仮想スクロール実装について要検討
			if (Math.round(e.target.scrollTop) >= e.target.scrollHeight - e.target.clientHeight && !this.isLoading && !this.limitMaxFlg) {
				this.offset += dataLimit
				this.getPainData()
			}
		},

		/**
		 * リロード処理
		 */
		reload () {
			this.isError = false
			this.getPainData()
		},

		/**
		 * コメントのチップ置換処理
		 */
		convertChipComment (comment) {
			// XSS攻撃対応で「<」と「>」をエスケープして、改行コードを<br>タグに変換してからパース処理
			const result = ZutoolChipParserWeb.ChipParser.parse(comment.replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/\n/g, '<br>'), this.chipData.records)
			return result.map(item => {
				if (item.type === 0) {
					return item.text
				} else {
					const record = this.chipData.records.find(chip => chip.name === item.text)
					return `<em class="is-chip is-type0${record.category}">${item.text}</em>`
				}
			}).join('')
		},

		/**
		 * コメント開閉クラス付与処理
		 */
		addCommentClass () {
			const elements = document.getElementsByClassName('pain-note-list__contents-comment')
			for (let i = this.offset, len = elements.length; i < len; i++) {
				const element = elements[i]
				this.$set(this.painDataList[i], 'comment_state', element.offsetHeight > 92 ? 'close' : 'hidden')
			}
		},

		/**
		 * 痛みソート処理
		 */
		sortPain (value) {
			if (!this.isLoading) {
				if (this.painLevels.indexOf(value) === -1) {
					this.painLevels.push(value)
				} else {
					this.painLevels = this.painLevels.filter(item => item !== value)
				}
				this.offset = 0
				this.limitMaxFlg = false
				this.painDataList = null
				if (this.painLevels.length !== 0) this.reload()
			}
		}
	}
}
</script>

<style lang="scss" scoped>
@import "@/assets/sass/variable";

// TODO: 元のデザインと若干表示が異なるので余裕があるときにリファクタリングしたい
.pain-note-list {
	$left-size: 45; // 左カラムサイズ
	$right-size: 20; // 右カラムサイズ
	$record-size: 40; // 痛み・薬アイコンカラムサイズ
	$pressure-level-icon-size: 45; // 気圧レベル実サイズ
	$pressure-level-icon-origin: 180; // 気圧レベル元サイズ
	$weather-icon-size: 24; // 天気アイコン実サイズ
	$weather-icon-origin: 69; // 天気アイコン元サイズ
	$pain-icon-size: 32; // 痛みアイコン実サイズ
	$pain-icon-origin: 99; // 痛みアイコン元サイズ
	$drug-icon-size: 32; // 薬アイコン実サイズ
	$drug-icon-origin: 99; // 薬アイコン元サイズ
	$drug-icon-multi-size: 20; // 複数服薬アイコン実サイズ。
	$list-item-border-color: #ccc;
	$pain-selector-height: 3rem;
	$spacing-28: 1.75rem;
	$spacing-44: 2.75rem;
	$spacing-92: 5.75rem;
	$color-chip-state: #E26B5C;
	$color-chip-record: #EB9C38;
	$color-chip-care: #83B75F;

	background: $_white;
	height: 100vh;	// dvhのフォールバック
	height: 100dvh;
	overflow: hidden;
	/deep/ .list {
		overflow: scroll;
		height: 100%;
	}
	&__pain-selector + .list {	// pain-selectorがある場合のスタイル
		height: calc(100% - #{$pain-selector-height});
	}
	.list-item {
		display: block;
		padding: 0;
		margin: 0;
		border-top: 1px solid $list-item-border-color;
		&:has(h2) { border-top: 0; }
	}
	&__empty {
		box-sizing: border-box;
		background: $background-secondary;
		height: 100%;
		padding: $spacing-20 0;
		p {
			background: $background-primary;
			width: 310px;
			margin: 0 auto;
			padding: $spacing-20 0;
			border-radius: $spacing-8;
			text-align: center;
		}
	}
	&__heading {
		display: block;
		color: $text-bold;
		font-size: $font-size-12;
		font-family: $family-primary;
		background: $background-secondary;
		border-top: 1px solid $background-list;
		border-bottom: 1px solid $background-list;
		width: 100%;
		height: 20px;
		min-height: initial;
		line-height: 20px;
		padding: 0 $spacing-10;
	}
	&__contents {
		display: flex;
		width: 100%;
		padding: $spacing-8;
		text-decoration: none;
		color: $text-bold;
		box-sizing: border-box;
		&-left {
			position: relative;
			width: #{$left-size}px;
		}
		&-time {
			display: block;
			font-size: $font-size-12;
			height: 28px;
			margin-top: -#{$spacing-8};
			line-height: 28px;
		}
		&-time-hour {
			font-size: $font-size-20;
			font-family: $family-primary;
		}
		&-left-bottom {
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			width: 100%;
			height: #{$left-size}px;
			margin: $spacing-8 0 0;
		}
		&-left-level-icon {
			position: absolute;
			transform: scale(calc(#{$pressure-level-icon-size} / #{$pressure-level-icon-origin}));
		}
		&-left-menstruation {
			$menstruation-icon-scale: .6;	// NOTE: 縮尺率はおおよその値
			position: absolute;
			transform: scale($menstruation-icon-scale);

			&.list_start_desc {
				transform-origin: 100% 0;
				top: $spacing-4;
				right: -#{$spacing-10};
			}
			&.list_during {
				transform-origin: 100% 0;
				top: calc(50% + 2px);
				transform: scale($menstruation-icon-scale) translateY(-50%);	// NOTE: 縮尺率はおおよその値
				right: -#{$spacing-4};
			}
			&.list_end_desc {
				transform-origin: 100% 100%;
				bottom: -#{$spacing-4};
				right: -#{$spacing-10};
			}
		}
		&-center {
			box-sizing: border-box;
			width: calc(100% - #{$left-size + $right-size}px);
			padding: 0 $spacing-4 0 $spacing-10;
		}
		&-center-inner {
			display: flex;
			flex-wrap: wrap;
			width: 100%;
			min-height: $spacing-40;
			box-sizing: border-box;
			& + & { margin-top: $spacing-10; }
			// NOTE: 薬情報を持っている場合のレイアウト
			&.is-have-drag {
				.pain-note-list__contents-pain { top: $spacing-10; }
				// .pain-note-list__contents-comment > p { padding-top: $spacing-4; }
			}
		}
		&-temperature {
			display: flex;
			align-items: center;
			box-sizing: border-box;
			border-left: 5px solid $background-weather;
			width: 100px;
			line-height: 1.4;
			padding-left: $spacing-2;
		}
		&-weather {
			width: #{$weather-icon-size}px;
			height: #{$weather-icon-size}px;
			margin-top: -#{$spacing-6};
			float: left;
		}
		&-weather-icon {
			transform: scale(calc(#{$weather-icon-size} / #{$weather-icon-origin}));
			transform-origin: 0 0;
		}
		&-pressure {
			display: flex;
			align-items: center;
			border-left: 5px solid $background-pressure-note;
			line-height: 1.3;
			padding-left: $spacing-2;
		}
		&-heading {
			white-space: nowrap;
			width: 50px;
			&.is-wide {
				width: 60px;
			}
		}
		&-unit {
			font-size: $font-size-10;
		}
		&-value {
			color: $text-bold;
			font-size: $font-size-14;
			font-family: $family-primary;
			padding-top: $spacing-18;
			&.is-wide {
				padding-top: 0;
			}
		}
		&-record {
			position: relative;
			box-sizing: border-box;
			width: #{$record-size}px;
			min-height: $spacing-44;
			padding-left: $spacing-2;
			border-left: 5px solid $background-pain;
		}
		&-pain {
			position: absolute;
			top: $spacing-6;
			left: 0;
			width: #{$pain-icon-size}px;
			height: #{$pain-icon-size}px;
			transform: scale(calc(#{$pain-icon-size} / #{$pain-icon-origin}));
			transform-origin: 0 0;
		}
		&-drug {
			position: absolute;
			top: -#{$spacing-4};
			left: 0;
			width: #{$drug-icon-size}px;
			height: #{$drug-icon-size}px;
			transform: scale(calc(#{$drug-icon-size} / #{$drug-icon-origin}));
			transform-origin: 0 0;

			&.sprite-drug4 {
				top: $spacing-2;
				left: $spacing-6;
				transform: scale(calc(#{$drug-icon-multi-size} / #{$drug-icon-origin}));
			}
		}
		&-medicine {
			font-size: $font-size-9;
			font-family: $family-secondary;
			width: calc(100% - #{$record-size}px);
			line-height: $line-height;
			word-break: break-all;
			text-align: justify;
			// NOTE: 薬名記録対応で追加
			p {
				margin: 0;
				padding-top: $spacing-4;
				box-sizing: border-box;
				&.is-empty::before { content: none; }

				// NOTE: 複数服薬で追加（変数はデザインシステム外）
				$spacing-3: 0.187rem;
				$color-medicine-tag: #FC4951;
				$color-prescription-tag: #1172D8;

				&.is-medicine::before {
					content: '市販薬';
					background-color: $color-medicine-tag;
				}
				&.is-prescription::before {
					content: '処方薬';
					background-color: $color-prescription-tag;
				}
				&.is-medicine::before,
				&.is-prescription::before  {
					font-family: $lp-family-primary;
					display: inline-block;
					text-align: center;
					margin: 0 $spacing-2 0 0;
					padding: 0 $spacing-3;
					color: $text-seconday;
					font-weight: normal;
					border-radius: 3px;
				}
			}
		}
		&-comment {
			position: relative;
			width: 100%;
			margin-top: $spacing-8;
			padding: $spacing-8 $spacing-30 $spacing-8 $spacing-8;
			font-size: $font-size-10;
			font-family: $family-secondary;
			line-height: $line-height;
			border-radius: $spacing-4;
			background-color: $background-secondary;
			box-sizing: border-box;
			overflow-wrap: break-word;

			& > p {
				width: 100%;
				margin: 0;
				text-align: justify;
			}
			& > svg {
				position: absolute;
				top: 50%;
				right: $spacing-8;
				transform: translateY(-50%);
			}
			// チップ
			/deep/ .is-chip {
				display: inline-block;
				padding: $spacing-4 $spacing-8;
				margin: 0 $spacing-4 $spacing-4;
				color: $text-seconday;
				background-color: $color-chip-state;	// デフォルトは様子
				font-style: normal;
				border-radius: $spacing-4;
				line-height: $line-height-1;

				&.is-type01 { background-color: $color-chip-state; }	// 様子
				&.is-type02 { background-color: $color-chip-record; }	// 記録
				&.is-type03 { background-color: $color-chip-care; }	// お世話
				&:first-child { margin: 0 $spacing-4 $spacing-4 0; }
			}
			/deep/ br + .is-chip { margin: $spacing-4 $spacing-4 $spacing-4 0; }

			// コメント開閉
			&.is-hidden {
				pointer-events: none;
				& > svg { display: none; }
			}
			&.is-close {
				max-height: $spacing-92;
				overflow: hidden;
				&::after {
					content: '';
					display: block;
					position: absolute;
					bottom: -#{$spacing-2};
					left: 0;
					width: 100%;
					height: $spacing-20;
					background: linear-gradient(to bottom, rgba($background-secondary, 0) 0%, rgba($background-secondary, 1) 50%, rgba($background-secondary, 1) 100%);
				}
				& > svg.is-close { display: block; }
				& > svg.is-open { display: none; }
			}
			&.is-open {
				max-height: none;
				& > svg.is-open { display: block; }
				& > svg.is-close { display: none; }
			}
		}
		&-right {
			width: #{$right-size}px;
			display: inline-flex;
			justify-content: center;
			align-items: center;

			&_icon path {
				width: 100%;
				stroke: $list-chevron-icon;
			}
		}
	}

	// 痛みソートUI
	&__pain-selector {
		position: relative;
		width: 100%;
		height: $pain-selector-height;
		padding: $spacing-8 $spacing-28;
		box-sizing: border-box;
		box-shadow: 0px $spacing-4 $spacing-4 0px rgba($_black, 0.1);
		z-index: 1;

		&--list {
			display: flex;
			justify-content: space-between;
			width: 100%;
			margin: 0;
			padding: 0 14.1066%;
			list-style: none;
			box-sizing: border-box;
		}

		&--item {
			width: #{$pain-icon-size}px;
			height: #{$pain-icon-size}px;
			position: relative;

			&.is-selected::before {
				content: '';
				display: block;
				position: absolute;
				top: 50%;
				left: 50%;
				width: 93.75%;
				height: 93.75%;
				transform: translate(-50%, -50%);
				box-sizing: border-box;
				border: solid $spacing-2 $primary;
				border-radius: $spacing-10;
			}

			& > a {
				display: block;
				text-decoration: none;
				overflow: hidden;

				& > i {
					transform: scale(calc(#{$pain-icon-size} / #{$pain-icon-origin}));
					transform-origin: 0 0;
				}
			}
		}
	}
}

.sprite {
	// background-image: url(~@/assets/img/pain_sprite_icon.png);
	background-image: url(~@/assets/img/sprite_pain_icon.png);	// こちらのスプライト画像を正とする
	background-repeat: no-repeat;
	display: block;
}

.sprite-drug2 {
	width: 99px;
	height: 99px;
	background-position: 0 0;
}

.sprite-drug3 {
	width: 99px;
	height: 99px;
	background-position: 0 -99px;
}

.sprite-pain1 {
	width: 99px;
	height: 99px;
	background-position: 0 -198px;
}

.sprite-pain2 {
	width: 99px;
	height: 99px;
	background-position: 0 -297px;
}

.sprite-pain3 {
	width: 99px;
	height: 99px;
	background-position: 0 -396px;
}

.sprite-pain4 {
	width: 99px;
	height: 99px;
	background-position: 0 -495px;
}

.sprite-pressure_level0 {
	width: 180px;
	height: 180px;
	background-position: 0 -774px;
}

.sprite-pressure_level1 {
	width: 180px;
	height: 180px;
	background-position: 0 -774px;
}

.sprite-pressure_level2 {
	width: 180px;
	height: 180px;
	background-position: 0 -954px;
}

.sprite-pressure_level3 {
	width: 180px;
	height: 180px;
	background-position: 0 -1134px;
}

.sprite-pressure_level4 {
	width: 180px;
	height: 180px;
	background-position: 0 -1314px;
}

.sprite-weather1 {
	width: 69px;
	height: 69px;
	background-position: 0 -1914px;
}

.sprite-weather2 {
	width: 69px;
	height: 69px;
	background-position: 0 -1983px;
}

.sprite-weather3 {
	width: 69px;
	height: 69px;
	background-position: 0 -2052px;
}

.sprite-weather4 {
	width: 69px;
	height: 69px;
	background-position: 0 -2121px;
}

// 上昇アラート追加
.sprite-pressure_level6 {
	width: 180px;
	height: 180px;
	background-position: 0 -2190px;
}

.sprite-pressure_level_bg6 {
	width: 106px;
	height: 105px;
	background-position: 0 -2370px;
}

// 複数服薬アイコン追加
.sprite-drug4 {
	width: 99px;
	height: 99px;
	background-position: 0 -2475px;
}

.sprite-pain1_off{
    width: 99px;
    height: 99px;
    background-position: 0 -2574px;
}

.sprite-pain2_off {
    width: 99px;
    height: 99px;
    background-position: 0 -2673px;
}

.sprite-pain3_off {
    width: 99px;
    height: 99px;
    background-position: 0 -2772px;
}

.sprite-pain4_off {
    width: 99px;
    height: 99px;
    background-position: 0 -2871px;
}

// ペットアイコンのスプライト
.sprite-pet {
	background-image: url(~@/assets/img/pet/sprite_pet_pain.png);
	background-repeat: no-repeat;
	display: block;

	&-pain0 {
		display: none;
	}

	&-pain1 {
		width: 99px;
		height: 99px;
		background-position: -5px -5px;
	}

	&-pain2 {
		width: 99px;
		height: 99px;
		background-position: -5px -114px;
	}

	&-pain3 {
		width: 99px;
		height: 99px;
		background-position: -5px -223px;
	}

	&-pain4 {
		width: 99px;
		height: 99px;
		background-position: -5px -332px;
	}

	&-pain1_off {
		width: 99px;
		height: 99px;
		background-position: -5px -441px;
	}

	&-pain2_off {
		width: 99px;
		height: 99px;
		background-position: -5px -550px;
	}

	&-pain3_off {
		width: 99px;
		height: 99px;
		background-position: -5px -659px;
	}

	&-pain4_off {
		width: 99px;
		height: 99px;
		background-position: -5px -768px;
	}
}

</style>
